import {
    ParticipantListTeamOutputsRequest,
    ParticipantListTeamOutputsResponse,
} from '@amzn/event-engine-events-sdk/clients/eventengineeventsservice';
import { useLazyRequest, usePaginator } from '@amzn/event-engine-js-utils';
import { AWSError } from 'aws-sdk';
import React, { useCallback, useEffect, useState } from 'react';
import { EEEvents } from 'services';

import { DEFAULT_PAGINATION_LIMIT } from './config';
import EventOutputsTable from './EventOutputsTable';
import {
    EventOutputsTableContainerProps,
    ParticipantStackOutputTableItem,
} from './types';

const EventOutputsTableContainer = ({
    participantId,
}: EventOutputsTableContainerProps) => {
    const [allData, setAllData] = useState<ParticipantStackOutputTableItem[]>(
        []
    );
    const [getOutputs, { data, isError, isLoading }] = useLazyRequest<
        typeof EEEvents.getParticipantEventOutputs,
        AWSError
    >(EEEvents.getParticipantEventOutputs, {});

    const paginator = usePaginator<
        ParticipantListTeamOutputsRequest,
        ParticipantListTeamOutputsResponse
    >(getOutputs, DEFAULT_PAGINATION_LIMIT, 'outputs');

    const getPaginatedData = useCallback((fresh: boolean = false) => {
        if (!participantId) {
            return;
        }
        return paginator.getPaginatedData<ParticipantListTeamOutputsRequest>(
            0,
            '*',
            {
                fresh,
                clientArgs: { participantId },
            }
        );
    }, []);

    useEffect(() => {
        getPaginatedData();
    }, []);

    useEffect(() => {
        if (data?.outputs) {
            setAllData([...allData, ...data.outputs]);
        }
    }, [data]);

    return (
        <EventOutputsTable
            outputs={allData}
            error={isError}
            loading={isLoading}
        />
    );
};

export default EventOutputsTableContainer;
